import { configureStore } from '@reduxjs/toolkit'
import buildingQuestionnaireAdminReducer from './slice'

const store = configureStore({
  reducer: {
    buildingQuestionnaireAdmin: buildingQuestionnaireAdminReducer,
  },
})

export default store
